import { withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-118ca7ce")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("input", {
    class: "digit-editbox",
    type: "tel",
    pattern: "\\d",
    maxlength: "1",
    value: _ctx.modelValue,
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('enter')), ["enter"]))
  }, null, 40, ["value"]))
})